<script setup lang="ts">
import { onMounted, ref } from 'vue'

declare global {
  interface Window {
    addWishlist?: (itemNumber: string, image: string, linkItemNumber: string) => void,
    removeWishlist?: (linkItemNumber: string) => void,
    hasWishlist?: (linkItemNumber: string) => boolean
  }
}

const props = defineProps<{
  itemNumber: string;
  image: string;
  linkItemNumber: string;
}>();

const isOnWishlist = ref(false)

const checkItemIsOnWishlist = () => {
  isOnWishlist.value = window?.hasWishlist ? window?.hasWishlist(props.linkItemNumber) : false
}

const addToWishList = () => {
  if (window?.addWishlist) {
    window?.addWishlist(props.itemNumber, props.image, props.linkItemNumber)
    isOnWishlist.value = true
  }
}

const toggleItemOnWishList = () => {
  if (isOnWishlist.value) {
    if (window?.removeWishlist) {
      window?.removeWishlist(props.linkItemNumber)
      isOnWishlist.value = false
    }
  } else {
    addToWishList()
  }
}

onMounted(() => {
  checkItemIsOnWishlist()
})
</script>

<template>
  <div class="wishlist-icon">
    <!-- wishlist icon -->
    <svg @click.stop.prevent="toggleItemOnWishList" v-if="!isOnWishlist" xmlns="http://www.w3.org/2000/svg"
         fill="none" viewBox="0 0 24 24" stroke-width="1.5"
         stroke="currentColor" class="w-6 cursor-pointer text-brand-main">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
    </svg>
    <svg @click.stop.prevent="toggleItemOnWishList" v-else xmlns="http://www.w3.org/2000/svg" fill="currentColor"
         viewBox="0 0 24 24" stroke-width="1.5"
         stroke="currentColor" class="w-6 cursor-pointer text-brand-main">
      <path stroke-linecap="round" stroke-linejoin="round"
            d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/>
    </svg>
  </div>
</template>

<style scoped>
</style>
